// extracted by mini-css-extract-plugin
export var active = "specialties-module--active--ad326";
export var airforce = "specialties-module--airforce--7499e";
export var airforceNationalGuard = "specialties-module--airforce-national-guard--8fab7";
export var airforceReserve = "specialties-module--airforce-reserve--83788";
export var airforce_icon_color = "specialties-module--airforce_icon_color--429cb";
export var army = "specialties-module--army--5ce58";
export var armyNationalGuard = "specialties-module--army-national-guard--e2402";
export var armyReserve = "specialties-module--army-reserve--600e5";
export var army_icon_color = "specialties-module--army_icon_color--97c10";
export var branch_text = "specialties-module--branch_text--b8b5b";
export var branches = "specialties-module--branches--2647b";
export var icon = "specialties-module--icon--9a138";
export var icons_group = "specialties-module--icons_group--236bf";
export var inner = "specialties-module--inner--8f53c";
export var key = "specialties-module--key--0ab61";
export var key_legend_section = "specialties-module--key_legend_section--39b17";
export var legend_text = "specialties-module--legend_text--f3315";
export var navy = "specialties-module--navy--de53d";
export var navyReserve = "specialties-module--navy-reserve--f2737";
export var navy_icon_color = "specialties-module--navy_icon_color--a065d";
export var open = "specialties-module--open--35df3";
export var rolesIcon = "specialties-module--roles-icon--12d1b";
export var roles_icon = "specialties-module--roles_icon--76c8e";
export var specialties = "specialties-module--specialties--2c0a5";
export var specialties_List = "specialties-module--specialties_List--41c8b";
export var title_text = "specialties-module--title_text--a9ef3";
export var title_text_group = "specialties-module--title_text_group--422d7";